import { FormEvent } from 'react';

import { PurchaseStates, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { PinValidateStatus } from '@kaltura-ott/tvpil-shared';

import { ValidatePin } from 'components/widgets/Modal/constants';
import { useModalContext } from 'context/modal/modal';

import { appErrorOnValidatePin } from '../../utils/appErrorOnValidatePin/appErrorOnValidatePin';
import { checkResetInput } from '../../utils/checkResetInput/checkResetInput';

interface Props {
  pinCode: string;
  pinLimitError:
    | {
        errorMessage: string;
        errorCode: string;
      }
    | undefined;
  context: UIDAPresentationTypeEnum | undefined;
  validatePin: ValidatePin;
  callback?: (success: boolean) => void;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setPinCode: React.Dispatch<React.SetStateAction<string>>;
  setError: React.Dispatch<
    React.SetStateAction<
      | {
          errorMessage: string;
          errorCode: string;
        }
      | undefined
    >
  >;
}

export const usePinCodeModalSubmit = ({
  context,
  pinCode,
  pinLimitError,
  setLoading,
  validatePin,
  callback,
  setPinCode,
  setError,
}: Props) => {
  const modalContext = useModalContext();

  return async function submit(event?: FormEvent) {
    if (event) {
      event.preventDefault();
    }

    setLoading(true);

    const result = await validatePin(pinCode);

    setLoading(false);

    if (!result && callback) {
      callback(false);
      return;
    }

    if (result && (result.state === PurchaseStates.error || result.state === PinValidateStatus.error)) {
      setPinCode('');
      setError(pinLimitError || { errorMessage: result.message || '', errorCode: result.code || '' });
      appErrorOnValidatePin(result, context);
      checkResetInput(result.message || '', pinCode, setPinCode);
      return;
    }

    modalContext.closeModal();

    if (callback) {
      callback(true);
    }
  };
};
